import { defineComponent as o, openBlock as t, createElementBlock as n, renderSlot as r } from "vue";
import "./icon.css";
const s = { class: "ap-icon" }, _ = /* @__PURE__ */ o({
  __name: "Icon",
  props: {
    size: {},
    color: {}
  },
  setup(c) {
    return (e, p) => (t(), n("i", s, [
      r(e.$slots, "default")
    ]));
  }
});
export {
  _ as default
};
